import {
  Alert,
  Button,
  Autocomplete,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useExportTemplate, useTemplates } from '../hooks/api/use-templates.hook';
import { CreateAutodeskTemplateFileForm } from '../components/AutodeskTemplateFiles/CreateAutodeskTemplateFileForm';

export const CreateAutodeskTemplateFile = () => {
  const navigate = useNavigate();

  const [exportTemplate, { error: createError }] = useExportTemplate();
  const { loading: loadingTemplates, response: templatesResponse } = useTemplates({});

  const {
    control,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CreateAutodeskTemplateFileForm>({
    resolver: classValidatorResolver(CreateAutodeskTemplateFileForm),
  });

  const onSubmit: SubmitHandler<CreateAutodeskTemplateFileForm> = async (values) => {
    const filePath = await exportTemplate({ templateId: values.template?.id });

    navigate('..');

    window.location.href = `${import.meta.env.VITE_CLOUDFRONT_URL}${filePath}`;
  };

  const renderContent = () => (
    <div>
      <Controller
        control={control}
        name="template"
        render={({ field }) => (
          <Autocomplete
            {...register('template')}
            loading={loadingTemplates}
            sx={{ mt: '1rem' }}
            onChange={(_event, selectedOptions) => field.onChange(selectedOptions)}
            onBlur={field.onBlur}
            value={field.value}
            getOptionLabel={(template) => template?.name ?? ''}
            options={templatesResponse?.pages.map(({ result }) => result).flat() ?? []}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Template"
                error={Boolean(errors.template)}
                helperText={errors.template?.message}
              />
            )}
          />
        )}
      />
    </div>
  );

  return (
    <Dialog open={true}>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: 600 }}>
        <DialogTitle>Civil 3D - Generate Template</DialogTitle>
        <DialogContent>
          {renderContent()}
          {createError ? (
            <Alert sx={{ mt: '1rem' }} severity="error">
              {createError?.response?.data?.message}
            </Alert>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button disabled={isSubmitting} variant="outlined" onClick={() => navigate('..')} color="primary">
            Cancel
          </Button>
          <LoadingButton color="primary" type="submit" variant="contained" loading={isSubmitting}>
            GENERATE
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};
